// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2756%27 height=%2756%27 viewBox=%270 0 56 56%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M28.949 34.2628L27.6706 32.9986L32.1096 28.5597H20.959V26.7131H32.1096L27.6706 22.2812L28.949 21.0099L35.5755 27.6364L28.949 34.2628Z%27 fill=%27white%27/%3E%3Ccircle cx=%2728%27 cy=%2728%27 r=%2727.5%27 stroke=%27white%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2756%27 height=%2756%27 viewBox=%270 0 56 56%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M27.051 21.7372L28.3294 23.0014L23.8904 27.4403L35.041 27.4403L35.041 29.2869L23.8904 29.2869L28.3294 33.7188L27.051 34.9901L20.4245 28.3636L27.051 21.7372Z%27 fill=%27white%27/%3E%3Ccircle cx=%2728%27 cy=%2728%27 r=%2727.5%27 transform=%27rotate%28180 28 28%29%27 stroke=%27white%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientsSaysSection_satisfiedCustomer__dYKBW {
  margin-bottom: 141px;
}
.ClientsSaysSection_satisfiedCustomer__dYKBW h6 {
  color: var(--Gray-900, #061c3d);
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 140% */
  margin-bottom: 24px;
}
.ClientsSaysSection_satisfiedCustomer__dYKBW h6 span {
  color: var(--Primary-500, #df7752);
}
.ClientsSaysSection_satisfiedCustomer__dYKBW .ClientsSaysSection_customersImage__MHsUt {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  max-width: 1277px;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .ClientsSaysSection_satisfiedCustomer__dYKBW .ClientsSaysSection_customersImage__MHsUt {
    justify-content: center;
  }
}

.swiper {
  width: 100% !important;
}

.ClientsSaysSection_sliderWrapper__10cI6 {
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  .ClientsSaysSection_sliderWrapper__10cI6 {
    margin-top: 60px;
  }
}
.ClientsSaysSection_sliderWrapper__10cI6 h2 {
  margin-bottom: 16px;
}
@media (max-width: 767px) {
  .ClientsSaysSection_sliderWrapper__10cI6 h2 {
    font-size: 22px;
  }
}
.ClientsSaysSection_sliderWrapper__10cI6 a {
  text-decoration: none;
}

.ClientsSaysSection_venueSliderWrapper__Ou9DK {
  margin-bottom: 120px;
}
.ClientsSaysSection_venueSliderWrapper__Ou9DK h2 {
  margin-bottom: 16px;
}
@media (max-width: 767px) {
  .ClientsSaysSection_venueSliderWrapper__Ou9DK h2 {
    font-size: 22px;
  }
}
.ClientsSaysSection_venueSliderWrapper__Ou9DK a {
  text-decoration: none;
}

.ClientsSaysSection_clientSays__-cnz7 .swiper-button-next {
  display: flex;
  border-radius: 100px;
  height: 40px !important;
  width: 40px !important;
  right: 20px;
  top: 45% !important;
  background: rgba(0, 0, 0, 0.2901960784);
  position: absolute;
  z-index: 10;
  cursor: pointer;
}
@media (max-width: 767px) {
  .ClientsSaysSection_clientSays__-cnz7 .swiper-button-next {
    height: 30px !important;
    width: 30px !important;
    right: 12px;
  }
}
.ClientsSaysSection_clientSays__-cnz7 .swiper-button-next::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 40px;
  width: 40px;
  background-size: 40px;
}
@media (max-width: 767px) {
  .ClientsSaysSection_clientSays__-cnz7 .swiper-button-next::after {
    height: 30px;
    width: 30px;
    background-size: 30px;
  }
}
.ClientsSaysSection_clientSays__-cnz7 .swiper-button-disabled {
  cursor: not-allowed;
  opacity: 0.5;
  display: none !important;
}
.ClientsSaysSection_clientSays__-cnz7 .swiper-button-prev {
  display: flex;
  border-radius: 100px;
  height: 40px !important;
  width: 40px !important;
  left: 20px;
  top: 45% !important;
  background: rgba(0, 0, 0, 0.2901960784);
  position: absolute;
  z-index: 10;
  cursor: pointer;
}
@media (max-width: 767px) {
  .ClientsSaysSection_clientSays__-cnz7 .swiper-button-prev {
    height: 30px !important;
    width: 30px !important;
    left: 12px;
  }
}
.ClientsSaysSection_clientSays__-cnz7 .swiper-button-prev::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  height: 40px;
  width: 40px;
  background-size: 40px;
  background-repeat: no-repeat;
}
@media (max-width: 767px) {
  .ClientsSaysSection_clientSays__-cnz7 .swiper-button-prev::after {
    height: 30px;
    width: 30px;
    background-size: 30px;
  }
}
.ClientsSaysSection_clientSays__-cnz7 .swiper {
  width: 100%;
}
.ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarPlaceholder__xibM2,
.ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarContainer__GHXMq {
  width: 100%;
  height: 100%;
}
@media (min-width: 768px) {
  .ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarPlaceholder__xibM2,
  .ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarContainer__GHXMq {
    width: 100%;
    height: 100%;
  }
}
.ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarPlaceholder__xibM2 img,
.ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarContainer__GHXMq img {
  width: 100%;
  height: 100%;
}
@media (max-width: 767px) {
  .ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarPlaceholder__xibM2 img,
  .ClientsSaysSection_clientSays__-cnz7 .swiper .ClientsSaysSection_avatarContainer__GHXMq img {
    width: 100%;
    height: 100%;
  }
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_title__W\\+H43 {
  color: var(--Gray-900, #061c3d);
  font-family: Roboto;
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  line-height: 60px; /* 125% */
  letter-spacing: -0.96px;
  text-transform: capitalize;
  margin-bottom: 24px;
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_subTitle__NEfa2 {
  color: #566b84;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 28.8px */
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk {
  display: flex;
  gap: 24px;
  padding: 70px 0 30px;
}
@media (max-width: 767px) {
  .ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk {
    padding: 70px 0 20px;
  }
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div {
  border-radius: 8px;
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(1) {
  background: var(--Secondary-50, #fff9ee);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(2) {
  background: var(--Success-50, #e7f5e8);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(3) {
  background: var(--Gray-50, #f5f6f7);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(4) {
  background: var(--Secondary-50, #fff9ee);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(5) {
  background: var(--Success-50, #e7f5e8);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(6) {
  background: var(--Gray-50, #f5f6f7);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(7) {
  background: var(--Secondary-50, #fff9ee);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(8) {
  background: var(--Success-50, #e7f5e8);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(9) {
  background: var(--Gray-50, #f5f6f7);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(10) {
  background: var(--Secondary-50, #fff9ee);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(11) {
  background: var(--Success-50, #e7f5e8);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-wrapper > div:nth-child(12) {
  background: var(--Gray-50, #f5f6f7);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientSlider__\\+klxk .swiper-slide {
  margin-right: 24px;
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientCard__aCf-D .ClientsSaysSection_cardContents__DUODb {
  padding: 36px 24px;
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientCard__aCf-D img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientCard__aCf-D .ClientsSaysSection_topContent__uD\\+vf {
  display: flex;
  gap: 12px;
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientCard__aCf-D .ClientsSaysSection_topContent__uD\\+vf p {
  color: var(--Gray-700, #42526b);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientCard__aCf-D .ClientsSaysSection_topContent__uD\\+vf p span {
  color: var(--Tertiary-500, #7534ff);
}
.ClientsSaysSection_clientSays__-cnz7 .ClientsSaysSection_clientCard__aCf-D p {
  color: var(--Gray-900, #061c3d);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 144.444% */
  margin: 6px 0 0px;
}

.ClientsSaysSection_viewMore__qnXR7 {
  color: #fff;
  text-decoration: none;
}
.ClientsSaysSection_viewMore__qnXR7 button {
  color: #fff;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0 36px !important;
  margin: 0 auto 80px;
  display: block;
  line-height: 46px;
}

.ClientsSaysSection_listingCard__-fAcl {
  border: 1px solid grey;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  cursor: pointer;
  text-decoration: none;
}
.ClientsSaysSection_listingCard__-fAcl p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_artistName__6bzqg {
  font-weight: 600;
  margin-bottom: 8px;
  -webkit-line-clamp: 1;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_cardContents__DUODb {
  padding: 16px;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_cardContents__DUODb .ClientsSaysSection_descriptionText__F1ZZg {
  margin-bottom: 12px;
  -webkit-line-clamp: 3;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_cardContents__DUODb p {
  margin-bottom: 4px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 15px;
  color: #4c4c51;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_cardContents__DUODb .ClientsSaysSection_priceText__JtoSD {
  font-size: 20px;
  margin-top: 24px;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_draftListing__lFTNr {
  background-color: rgba(0, 0, 0, 0.6901960784);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: 600;
  z-index: 1;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_noImage__P9Vbe {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_noImage__P9Vbe p {
  font-weight: 600;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_noImage__P9Vbe svg {
  width: 40%;
  height: 40%;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_listingImage__\\+skKw {
  position: relative;
  width: 100%;
  padding-top: 72%;
  border-bottom: 1px solid grey;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_listingImage__\\+skKw:hover {
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1019607843);
  transform: scale(1.02);
  transition: ease-in-out 0.1s;
  cursor: pointer;
}
.ClientsSaysSection_listingCard__-fAcl .ClientsSaysSection_listingImage__\\+skKw img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ClientsSaysSection/ClientsSaysSection.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AAAE;EACE,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,mBAAA;AAEJ;AADI;EACE,kCAAA;AAGN;AAAE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,8BAAA;AAEJ;AADI;EANF;IAOI,uBAAA;EAIJ;AACF;;AADA;EACE,sBAAA;AAIF;;AAFA;EACE,mBAAA;AAKF;AAJE;EAFF;IAGI,gBAAA;EAOF;AACF;AANE;EACE,mBAAA;AAQJ;AAPI;EAFF;IAGI,eAAA;EAUJ;AACF;AARE;EACE,qBAAA;AAUJ;;AAPA;EACE,oBAAA;AAUF;AATE;EACE,mBAAA;AAWJ;AAVI;EAFF;IAGI,eAAA;EAaJ;AACF;AAXE;EACE,qBAAA;AAaJ;;AATI;EACE,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAYN;AAXM;EAXF;IAYI,uBAAA;IACA,sBAAA;IACA,WAAA;EAcN;AACF;AAZI;EACE,WAAA;EACF,yDAAA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AAcN;AAbM;EANF;IAOI,YAAA;IACA,WAAA;IACA,qBAAA;EAgBN;AACF;AAdI;EACE,mBAAA;EACA,YAAA;EACA,wBAAA;AAgBN;AAdI;EACE,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAgBN;AAfM;EAXF;IAYI,uBAAA;IACA,sBAAA;IACA,UAAA;EAkBN;AACF;AAhBI;EACE,WAAA;EACA,yDAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,4BAAA;AAkBN;AAjBM;EAPF;IAQI,YAAA;IACA,WAAA;IACA,qBAAA;EAoBN;AACF;AAlBI;EACE,WAAA;AAoBN;AAnBM;;EAEE,WAAA;EACA,YAAA;AAqBR;AApBQ;EAJF;;IAKI,WAAA;IACA,YAAA;EAwBR;AACF;AAvBQ;;EACE,WAAA;EACA,YAAA;AA0BV;AAzBU;EAHF;;IAII,WAAA;IACA,YAAA;EA6BV;AACF;AAzBE;EACE,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;AA2BJ;AAzBE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA2BJ;AAzBE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AA2BJ;AA1BI;EAJF;IAKI,oBAAA;EA6BJ;AACF;AA3BM;EACE,kBAAA;AA6BR;AA5BQ;EACE,wCAAA;AA8BV;AA5BQ;EACE,sCAAA;AA8BV;AA5BQ;EACE,mCAAA;AA8BV;AA5BQ;EACE,wCAAA;AA8BV;AA5BQ;EACE,sCAAA;AA8BV;AA5BQ;EACE,mCAAA;AA8BV;AA5BQ;EACE,wCAAA;AA8BV;AA5BQ;EACE,sCAAA;AA8BV;AA5BQ;EACE,mCAAA;AA8BV;AA5BQ;EACE,wCAAA;AA8BV;AA5BQ;EACE,sCAAA;AA8BV;AA5BQ;EACE,mCAAA;AA8BV;AA1BI;EACE,kBAAA;AA4BN;AAxBI;EACE,kBAAA;AA0BN;AAxBI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,0BAAA;AA0BN;AAxBI;EACE,aAAA;EACA,SAAA;AA0BN;AAzBM;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,SAAA;AA2BR;AA1BQ;EACE,mCAAA;AA4BV;AAxBI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,iBAAA;AA0BN;;AAtBA;EACE,WAAA;EACA,qBAAA;AAyBF;AAxBE;EACE,WAAA;EACA,uBAAA;EAAA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AA0BJ;;AAvBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA0BF;AAxBE;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AA0BJ;AAxBE;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;AA0BJ;AAxBE;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA0BJ;AAzBI;EACE,mBAAA;EACA,qBAAA;AA2BN;AAzBI;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;AA2BN;AAzBI;EACE,eAAA;EACA,gBAAA;AA2BN;AAxBE;EACE,6CAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AA0BJ;AAxBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;AA0BJ;AAzBI;EACE,gBAAA;AA2BN;AAzBI;EACE,UAAA;EACA,WAAA;AA2BN;AAxBE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;AA0BJ;AAzBI;EACE,kDAAA;EACA,sBAAA;EACA,4BAAA;EACA,eAAA;AA2BN;AAzBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;AA2BN","sourcesContent":[".satisfiedCustomer {\n  margin-bottom: 141px;\n  & h6 {\n    color: var(--Gray-900, #061c3d);\n    text-align: center;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 28px; /* 140% */\n    margin-bottom: 24px;\n    & span {\n      color: var(--Primary-500, #df7752);\n    }\n  }\n  & .customersImage {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 32px;\n    max-width: 1277px;\n    justify-content: space-between;\n    @media (max-width: 767px) {\n      justify-content: center;\n    }\n  }\n}\n:global(.swiper){\n  width: 100% !important;\n}\n.sliderWrapper{\n  margin-bottom: 60px;\n  @media (max-width: 767px) {\n    margin-top: 60px;\n  }\n  & h2{\n    margin-bottom: 16px;\n    @media (max-width: 767px) {\n      font-size: 22px;\n    }\n  }\n  & a{\n    text-decoration: none;\n  }\n}\n.venueSliderWrapper{\n  margin-bottom: 120px;\n  & h2{\n    margin-bottom: 16px;\n    @media (max-width: 767px) {\n      font-size: 22px;\n    }\n  }\n  & a{\n    text-decoration: none;\n  }\n}\n.clientSays {\n    & :global(.swiper-button-next){\n      display: flex;\n      border-radius: 100px;\n      height: 40px !important;\n      width: 40px !important;\n      right: 20px;\n      top: 45% !important;\n      background: #0000004a;\n      position: absolute;\n      z-index: 10;\n      cursor: pointer;\n      @media (max-width: 767px) {\n        height: 30px !important;\n        width: 30px !important;\n        right: 12px;\n      }\n    }\n    & :global(.swiper-button-next::after){\n      content: \"\";\n    background-image: url(\"data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M28.949 34.2628L27.6706 32.9986L32.1096 28.5597H20.959V26.7131H32.1096L27.6706 22.2812L28.949 21.0099L35.5755 27.6364L28.949 34.2628Z' fill='white'/%3E%3Ccircle cx='28' cy='28' r='27.5' stroke='white'/%3E%3C/svg%3E%0A\");\n      height: 40px;\n      width: 40px;\n      background-size: 40px;\n      @media (max-width: 767px) {\n        height: 30px;\n        width: 30px;\n        background-size: 30px;\n      }\n    }\n    & :global(.swiper-button-disabled) {\n      cursor: not-allowed;\n      opacity: 0.5;\n      display: none !important;\n    }\n    & :global(.swiper-button-prev){\n      display: flex;\n      border-radius: 100px;\n      height: 40px !important;\n      width: 40px !important;\n      left: 20px;\n      top: 45% !important;\n      background: #0000004a;\n      position: absolute;\n      z-index: 10;\n      cursor: pointer;\n      @media (max-width: 767px) {\n        height: 30px !important;\n        width: 30px !important;\n        left: 12px;\n      }\n    }\n    & :global(.swiper-button-prev::after){\n      content: \"\";\n      background-image: url(\"data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.051 21.7372L28.3294 23.0014L23.8904 27.4403L35.041 27.4403L35.041 29.2869L23.8904 29.2869L28.3294 33.7188L27.051 34.9901L20.4245 28.3636L27.051 21.7372Z' fill='white'/%3E%3Ccircle cx='28' cy='28' r='27.5' transform='rotate(180 28 28)' stroke='white'/%3E%3C/svg%3E%0A\");\n      height: 40px;\n      width: 40px;\n      background-size: 40px;\n      background-repeat: no-repeat;\n      @media (max-width: 767px) {\n        height: 30px;\n        width: 30px;\n        background-size: 30px;\n      }\n    }\n    & :global(.swiper) {\n      width: 100%;\n      .avatarPlaceholder,\n      .avatarContainer {\n        width: 100%;\n        height: 100%;\n        @media (min-width: 768px) {\n          width: 100%;\n          height: 100%;\n        }\n        & img {\n          width: 100%;\n          height: 100%;\n          @media (max-width: 767px) {\n            width: 100%;\n            height: 100%;\n          }\n        }\n      }\n    }\n  & .title {\n    color: var(--Gray-900, #061c3d);\n    font-family: Roboto;\n    font-size: 48px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 60px; /* 125% */\n    letter-spacing: -0.96px;\n    text-transform: capitalize;\n    margin-bottom: 24px;\n  }\n  & .subTitle {\n    color: #566b84;\n    font-family: Roboto;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 160%; /* 28.8px */\n  }\n  & .clientSlider {\n    display: flex;\n    gap: 24px;\n    padding: 70px 0 30px;\n    @media (max-width: 767px) {\n      padding: 70px 0 20px;\n    }\n    & :global(.swiper-wrapper) {\n      & > div {\n        border-radius: 8px;\n        &:nth-child(1) {\n          background: var(--Secondary-50, #fff9ee);\n        }\n        &:nth-child(2) {\n          background: var(--Success-50, #e7f5e8);\n        }\n        &:nth-child(3) {\n          background: var(--Gray-50, #f5f6f7);\n        }\n        &:nth-child(4) {\n          background: var(--Secondary-50, #fff9ee);\n        }\n        &:nth-child(5) {\n          background: var(--Success-50, #e7f5e8);\n        }\n        &:nth-child(6) {\n          background: var(--Gray-50, #f5f6f7);\n        }\n        &:nth-child(7) {\n          background: var(--Secondary-50, #fff9ee);\n        }\n        &:nth-child(8) {\n          background: var(--Success-50, #e7f5e8);\n        }\n        &:nth-child(9) {\n          background: var(--Gray-50, #f5f6f7);\n        }\n        &:nth-child(10) {\n          background: var(--Secondary-50, #fff9ee);\n        }\n        &:nth-child(11) {\n          background: var(--Success-50, #e7f5e8);\n        }\n        &:nth-child(12) {\n          background: var(--Gray-50, #f5f6f7);\n        }\n      }\n    }\n    & :global(.swiper-slide) {\n      margin-right: 24px;\n    }\n  }\n  & .clientCard {\n    & .cardContents {\n      padding: 36px 24px;\n    }\n    & img {\n      width: 100%;\n      height: 200px;\n      object-fit: cover;\n      border-radius: 8px 8px 0 0;\n    }\n    & .topContent {\n      display: flex;\n      gap: 12px;\n      & p {\n        color: var(--Gray-700, #42526b);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px; /* 142.857% */\n        margin: 0;\n        & span {\n          color: var(--Tertiary-500, #7534ff);\n        }\n      }\n    }\n    & p {\n      color: var(--Gray-900, #061c3d);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 26px; /* 144.444% */\n      margin: 6px 0 0px;\n    }\n  }\n}\n.viewMore{\n  color: #fff;\n  text-decoration: none;\n  & button{\n    color: #fff;\n    width: fit-content;\n    padding: 0 36px !important;\n    margin: 0 auto 80px;\n    display: block;\n    line-height: 46px;\n  }\n}\n.listingCard {\n  border: 1px solid grey;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.05);\n  position: relative;\n  cursor: pointer;\n  text-decoration: none;\n\n  & p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  }\n  & .artistName {\n    font-weight: 600;\n    margin-bottom: 8px;\n    -webkit-line-clamp: 1;\n  }\n  & .cardContents {\n    padding: 16px;\n    min-height: 140px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    & .descriptionText {\n      margin-bottom: 12px;\n      -webkit-line-clamp: 3;\n    }\n    & p {\n      margin-bottom: 4px;\n      word-break: break-word;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      font-size: 15px;\n      color: #4c4c51;\n    }\n    & .priceText {\n      font-size: 20px;\n      margin-top: 24px;\n    }\n  }\n  & .draftListing {\n    background-color: #000000b0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffff;\n    font-size: 24px;\n    font-weight: 600;\n    z-index: 1;\n  }\n  & .noImage {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    text-align: center;\n    & p {\n      font-weight: 600;\n    }\n    & svg {\n      width: 40%;\n      height: 40%;\n    }\n  }\n  & .listingImage {\n    position: relative;\n    width: 100%;\n    padding-top: 72%;\n    border-bottom: 1px solid grey;\n    &:hover {\n      box-shadow: 0 0 50px 0 #0000001a;\n      transform: scale(1.02);\n      transition: ease-in-out 0.1s;\n      cursor: pointer;\n    }\n    & img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      text-align: center;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"satisfiedCustomer": `ClientsSaysSection_satisfiedCustomer__dYKBW`,
	"customersImage": `ClientsSaysSection_customersImage__MHsUt`,
	"sliderWrapper": `ClientsSaysSection_sliderWrapper__10cI6`,
	"venueSliderWrapper": `ClientsSaysSection_venueSliderWrapper__Ou9DK`,
	"clientSays": `ClientsSaysSection_clientSays__-cnz7`,
	"avatarPlaceholder": `ClientsSaysSection_avatarPlaceholder__xibM2`,
	"avatarContainer": `ClientsSaysSection_avatarContainer__GHXMq`,
	"title": `ClientsSaysSection_title__W+H43`,
	"subTitle": `ClientsSaysSection_subTitle__NEfa2`,
	"clientSlider": `ClientsSaysSection_clientSlider__+klxk`,
	"clientCard": `ClientsSaysSection_clientCard__aCf-D`,
	"cardContents": `ClientsSaysSection_cardContents__DUODb`,
	"topContent": `ClientsSaysSection_topContent__uD+vf`,
	"viewMore": `ClientsSaysSection_viewMore__qnXR7`,
	"listingCard": `ClientsSaysSection_listingCard__-fAcl`,
	"artistName": `ClientsSaysSection_artistName__6bzqg`,
	"descriptionText": `ClientsSaysSection_descriptionText__F1ZZg`,
	"priceText": `ClientsSaysSection_priceText__JtoSD`,
	"draftListing": `ClientsSaysSection_draftListing__lFTNr`,
	"noImage": `ClientsSaysSection_noImage__P9Vbe`,
	"listingImage": `ClientsSaysSection_listingImage__+skKw`
};
export default ___CSS_LOADER_EXPORT___;
